import {
  OPERATORS_FETCH,
  OPERATORS_FETCH_FAILURE,
  OPERATORS_FETCH_SUCCESS,
  OPERATORS_RESET,
  OPERATORS_SET,
} from "../actionTypes";

const INITIAL_STATE = {
  operators: [],
  loading: false,
  error: null,
};

export default function OperatorsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case OPERATORS_FETCH:
      return { ...state, loading: true, error: null };
    case OPERATORS_FETCH_SUCCESS: {
      const { payload } = action;
      return { ...state, operators: payload, loading: false, error: null };
    }
    case OPERATORS_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    case OPERATORS_SET: {
      const { payload } = action;
      return { ...state, operators: payload };
    }
    case OPERATORS_RESET: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}
